import { enviroments } from '@infrastructure/enviroments';
import { PageLimitFilter } from '@typings';

import { baseClient } from 'src/app/baseClient';

import {
  ContextListResponse,
  CreateTenantRequest,
  EditTenantRequest,
  GetTenantByIdResponse,
  GetTenantListRequest,
  GetTenantListResponse,
  VerifyTenantAliasIdResponse,
} from './tenantApiTypes';

const BASE_URL = enviroments.BASE_URL;
const BASE_API_PATH = 'tenants';

async function getTenantList({
  page,
  limit,
  filter,
  order,
}: PageLimitFilter): Promise<GetTenantListResponse> {
  let where = {};
  if (filter) {
    Object.keys(filter).forEach(key => {
      if (filter[key]) {
        where = {
          ...where,
          [key]: filter[key],
        };
      }
    });
  }

  const params: GetTenantListRequest = {
    ...where,
    limit,
    page,
    order,
  };

  const { data } = await baseClient({
    baseURL: BASE_URL,
    url: `/${BASE_API_PATH}`,
    method: 'GET',
    params,
  });

  return data;
}

async function changeTenantStatus(tenantId: number): Promise<void> {
  await baseClient({
    baseURL: BASE_URL,
    url: `/${BASE_API_PATH}/${tenantId}/toggle-status`,
    method: 'PATCH',
  });
}

async function getContextList(): Promise<ContextListResponse> {
  const { data } = await baseClient({
    baseURL: BASE_URL,
    url: `/${BASE_API_PATH}/context-list`,
    method: 'GET',
  });
  return data;
}

async function verifyTenantAlias(
  tenantAliasId: string
): Promise<VerifyTenantAliasIdResponse> {
  const { data } = await baseClient({
    baseURL: BASE_URL,
    url: `/${BASE_API_PATH}/${tenantAliasId}/verify`,
    method: 'GET',
  });
  return data;
}

async function createTenant(payload: CreateTenantRequest): Promise<void> {
  await baseClient({
    baseURL: BASE_URL,
    url: `/${BASE_API_PATH}`,
    method: 'POST',
    data: payload,
  });
}

async function getTenantById(id: number): Promise<GetTenantByIdResponse> {
  const { data } = await baseClient({
    baseURL: BASE_URL,
    url: `/${BASE_API_PATH}/${id}`,
    method: 'GET',
  });
  return data;
}

async function editTenant(
  id: number,
  payload: EditTenantRequest
): Promise<void> {
  await baseClient({
    baseURL: BASE_URL,
    url: `/${BASE_API_PATH}/${id}`,
    method: 'PATCH',
    data: payload,
  });
}

export const tenantsApi = {
  getTenantList,
  changeTenantStatus,
  getContextList,
  verifyTenantAlias,
  createTenant,
  getTenantById,
  editTenant,
};
